import * as hist from "history";
const history = hist.createHashHistory();
export default history;
